import { FIREBASE_TOKEN } from "../constants/auth";
// import axios from "axios";

export const SetFirebaseAuthToken = (values) => async (dispatch) => {
  dispatch({
    type: FIREBASE_TOKEN,
    payload: values,
  });
};
